import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { UsersnapService } from './shared/services/usersnap.service';
import { environment } from '../environments/environment.prod';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, map } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'aim_frontend';
  public isOpen: boolean =false;
  public isToggle: boolean =false;
  private userName: string = '';
  private userEmail: string = '';
  public isAuth = false;

  constructor(private router: Router, private usersnapService: UsersnapService, private cookieService: CookieService, private ngZone: NgZone  ) {
  }

  ngOnInit() {
    this.usersnapService.authChanges$.subscribe(user => {
      if (user) {
        this.userName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
        this.userEmail = user.email;
      } else {
        this.userName = '';
        this.userEmail = '';
      }
    });

    this.usersnapService.bugWidgetChanges$.subscribe(bugWidget => {
      if (bugWidget) {
        this.openBugWidget();
      }
    });

  }
  isAuthRoute(): boolean {
    const authRoutes = ['/auth/login', '/auth/register', '/auth/forget-password', '/sign-offer', '/sign-offer/signed', '/sign-offer/error', '/guide'];
    
    const purePath = this.router.url.split('?')[0];
    
    return authRoutes.includes(purePath);
  }

  toggleSidebar(event:null){
    this.isOpen =! this.isOpen;
  }

  smallSidebar(event:null) {
    this.isToggle =! this.isToggle;
  }


  openFeedback() { this.usersnapService.logEvent('open-feedback'); }

  async openBugWidget() {
    await this.usersnapService.init(
      environment.USERSNAP_SPACE_KEY,
      { name: this.userName, email: this.userEmail },
      { appVersion: environment.USERSNAP_APP_VERSION, env: environment.USERSNAP_NAME }
    );
    if (environment.USERSNAP_BUG_WIDGET_KEY) {
      this.usersnapService.showProject(environment.USERSNAP_BUG_WIDGET_KEY);
    }
  }
}
